/* unplugin-vue-components disabled */import { render } from "./AdvancedDoughnutChart.vue?vue&type=template&id=4b0cf2e0&scoped=true&ts=true"
import script from "./AdvancedDoughnutChart.vue?vue&type=script&lang=ts"
export * from "./AdvancedDoughnutChart.vue?vue&type=script&lang=ts"

import "./AdvancedDoughnutChart.vue?vue&type=style&index=0&id=4b0cf2e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0cf2e0"]])

export default __exports__